<template>
    <el-card>
        <div>{{ newCardFragmentParams.id ? `编辑碎片: ${newCardFragmentParams.id}` : "新增碎片" }}
            <CopyButton v-if="newCardFragmentParams.id" :text="newCardFragmentParams.id" />
        </div>
        <el-divider />
        <el-form :model="newCardFragmentParams" label-width="100px">
            <el-row>
                <el-col :span="24">
                    <el-form-item label="名称" prop="name" required>
                        <el-input v-model="newCardFragmentParams.name" />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="图片" prop="image">
                        <SingleImageUploader v-if="!newCardFragmentParams.id" v-model="newCardFragmentParams.image">
                        </SingleImageUploader>
                        <el-image v-else :src="newCardFragmentParams.image" fit="cover"
                            style="width: 100%; max-width: 180px; height: 240px; border-radius: 8px;" />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="排序值" prop="sort">
                        <el-input-number v-model="newCardFragmentParams.sort" />
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <el-divider />
        <div>{{ "配置卡包内可抽取卡片" }} ({{ !imageSelectorParam.showForm ? '显示表格' : '显示图片' }}<el-switch
                v-model="imageSelectorParam.showForm" />)</div>
        <el-divider />

        <el-form v-if="!imageSelectorParam.showForm" :model="newCardFragmentParams.cards" label-width="100px">
            <template v-for="(card, index) in newCardFragmentParams.cards" :key="index">
                <el-row :gutter="20" align="top" class="card-config">
                    <el-col :span="6">
                        <el-badge :value="index + 1" type="primary">
                            <el-image :src="cardStore.cardsObj[card.cardId]?.image" fit="cover"
                                style="width: 100%;max-width: 180px; height: 240px; border-radius: 8px;" />
                        </el-badge>
                    </el-col>
                    <el-col :span="18">
                        <el-form :model="card" label-width="160px">
                            <el-form-item label="卡片名称(ID)">
                                {{ cardStore.cardsObj[card.cardId]?.name }} ({{ card.cardId }})
                                <el-link style="margin-left: 12px;" underline="always" type="primary"
                                    @click="deleteCard(index)">{{
                                        "删除"
                                    }}</el-link>
                            </el-form-item>
                            <el-form-item label="卡片稀有度(价值)">
                                {{ cardStore.cardsObj[card.cardId]?.rarity }} ({{ cardStore.cardsObj[card.cardId]?.value
                                }})
                            </el-form-item>
                            <el-form-item label="总数" required>
                                <el-input v-model="card.total" />
                            </el-form-item>
                            <el-form-item label="剩余" required>
                                <el-input v-model="card.rest" />
                            </el-form-item>
                            <el-form-item label="抽中概率" required>
                                <el-input :disabled="newCardFragmentParams.cards.length - 1 === index"
                                    v-model="card.rate" />
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-row>
            </template>
        </el-form>

        <el-table v-else :data="newCardFragmentParams.cards" border style="width: 100%; margin-top: 10px">
            <el-table-column label="操作" width="60" align="center">
                <template #default="{ $index }">
                    <el-link underline="always" type="primary" @click="deleteCard($index)">{{
                        "删除"
                        }}</el-link>
                </template>
            </el-table-column>
            <el-table-column label="Name" prop="name" width="180">
                <template #default="{ row }">
                    {{ cardStore.cardsObj[row.cardId]?.name }}
                </template>
            </el-table-column>
            <el-table-column label="稀有度" prop="rarity" width="80">
                <template #default="{ row }">
                    {{ cardStore.cardsObj[row.cardId]?.rarity }}
                </template>
            </el-table-column>
            <el-table-column label="价值" prop="value" width="80">
                <template #default="{ row }">
                    {{ cardStore.cardsObj[row.cardId]?.value }}
                </template>
            </el-table-column>
            <el-table-column label="总数">
                <template #default="{ row, $index }">
                    <el-input v-model="row.total" />
                </template>
            </el-table-column>
            <el-table-column label="剩余">
                <template #default="{ row, $index }">
                    <el-input v-model="row.rest" />
                </template>
            </el-table-column>
            <el-table-column label="抽中概率">
                <template #default="{ row, $index }">
                    <el-input :disabled="newCardFragmentParams.cards.length - 1 === $index" v-model="row.rate" />
                </template>
            </el-table-column>
            <el-table-column label="ID" prop="cardId" width="180"></el-table-column>
        </el-table>

        <el-row>
            <el-col :span="6">
                <el-button type="primary" @click="addCard">
                    增加卡片<el-icon class="el-icon--right">
                        <Plus />
                    </el-icon>
                </el-button>
            </el-col>
        </el-row>

        <template #footer>
            <el-button @click="cancel">取消</el-button>
            <el-button v-if="!newCardFragmentParams.id" @click="resetAll">清空</el-button>
            <el-button v-if="!newCardFragmentParams.id" v-loading="newCardFragmentParams.loading" type="primary"
                @click="submitAddCardFragment">新增</el-button>
            <el-button v-if="!!newCardFragmentParams.id" v-loading="newCardFragmentParams.loading" type="primary"
                @click="submitEditCardFragment">保存</el-button>
        </template>
    </el-card>

    <!-- 图片选择弹窗 -->
    <el-dialog v-model="imageSelectorParam.showImageSelector" title="选择图片" width="600px" :close-on-click-modal="false">
        <div style="margin-bottom: 10px; display: flex; gap: 10px;">
            <el-input v-model="imageSelectorParam.searchName" clearable prefix-icon="Search" style="flex: 1;" />
            <el-select v-model="imageSelectorParam.rarity" class="level-select" placeholder="稀有度" clearable
                style="width: 100px">
                <el-option v-for="r in ALL_RARITY" :key="r" :label="r" :value="r" />
            </el-select>
        </div>
        <div class="image-grid">
            <template v-for="card in filteredImages" :key="card.id">
                <div class="image-grid-inner"
                    :class="{ selected: imageSelectorParam.selectedImages.includes(card.id) }">
                    <el-image :src="card.image" fit="cover" class="image-option" @click="toggleSelect(card.id)" />
                    <span>{{ card.name }}</span>
                    <span>{{ card.rarity }}: {{ card.value }}</span>
                </div>
            </template>
        </div>
        <template #footer>
            <el-button @click="imageSelectorParam.showImageSelector = false">取消</el-button>
            <el-button @click="selectImage" type="primary">确定</el-button>
        </template>
    </el-dialog>
</template>

<script setup>
import { ref, reactive, computed, watch, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { ElMessage, ElMessageBox } from "element-plus";
import { ALL_RARITY } from "@/utils/constant";
import { apiCall } from "@/utils/api";
import { useCardStore } from "@/stores/card/card";

const cardStore = useCardStore();
const route = useRoute();
const router = useRouter();

const loading = ref(false);

const imageSelectorParam = reactive({
    showImageSelector: false,
    showForm: false,
    selectedImages: [],
    searchName: "",
    rarity: "",
});

const filteredImages = computed(() => {
    if (!imageSelectorParam.searchName && !imageSelectorParam.rarity) return cardStore.cards;
    const keyword = (imageSelectorParam.searchName || "").toLowerCase();
    const rarity = (imageSelectorParam.rarity || "").toLowerCase();
    const rtnCards = cardStore.cards.filter((card) => {
        let flg = true;
        if (keyword && !card.name.toLowerCase().includes(keyword)) {
            flg = false;
        }
        if (rarity && rarity !== card.rarity.toLowerCase()) {
            flg = false;
        }
        return flg;
    });
    return rtnCards;
});

const newCardFragmentParams = reactive({
    id: "",
    name: "",
    image: "",
    sort: 50,
    cards: [],
});

function calcLastRate() {
    let totalRate = 0;

    for (let index = 0; index < newCardFragmentParams.cards.length - 1; index++) {
        totalRate += 100 * newCardFragmentParams.cards[index].rate;
    }

    newCardFragmentParams.cards[newCardFragmentParams.cards.length - 1].rate = (10000 - totalRate) / 100;
}

watch(
    () => newCardFragmentParams.cards.map(c => c.rate),
    () => {
        calcLastRate();
    },
    { deep: false }
);

async function loadData(id) {
    loading.value = true;
    const response = await apiCall("card.getFragment", { id });
    if (!response) {
        loading.value = false;
        return false;
    }

    Object.keys(newCardFragmentParams).forEach(key => {
        newCardFragmentParams[key] = response[key];
    });

    loading.value = false;
}

async function resetAll() {
    newCardFragmentParams.loading = true;

    // newCardFragmentParams.id = "";
    newCardFragmentParams.name = "";
    newCardFragmentParams.image = "";
    newCardFragmentParams.sort = 50;

    newCardFragmentParams.cards = [];

    newCardFragmentParams.loading = false;
}

function addCard() {
    imageSelectorParam.selectedImages = (newCardFragmentParams.cards || []).map(c => c.cardId);
    imageSelectorParam.showImageSelector = true;
}

function toggleSelect(cardId) {
    const existsIdx = imageSelectorParam.selectedImages.indexOf(cardId);
    if (existsIdx > -1) {
        imageSelectorParam.selectedImages.splice(existsIdx, 1);
    } else {
        imageSelectorParam.selectedImages.push(cardId);
    }
}

function selectImage() {
    newCardFragmentParams.cards = newCardFragmentParams.cards || [];
    const cardIds = newCardFragmentParams.cards.map(card => card.cardId);

    for (let idx = cardIds.length - 1; idx > -1; idx--) {
        if (imageSelectorParam.selectedImages.includes(cardIds[idx])) {
            continue;
        }
        cardIds.splice(idx, 1);
        newCardFragmentParams.cards.splice(idx, 1);
    }

    for (let cardId of imageSelectorParam.selectedImages) {
        if (cardIds.includes(cardId)) {
            continue;
        }
        const card = cardStore.cardsObj[cardId];
        if (!card) {
            continue;
        }
        newCardFragmentParams.cards.push({
            id: "",
            cardId: card.id,
            total: 0,
            rest: 0,
            rate: 0,
        });
    }

    newCardFragmentParams.cards.sort((a, b) => {
        if (a.rarity === b.rarity) {
            return b.value - a.value;
        } else {
            return ALL_RARITY.value.indexOf(a.rarity) - ALL_RARITY.value.indexOf(b.rarity);
        }
    });
    imageSelectorParam.showImageSelector = false;
}

function deleteCard(index) {
    const dc = newCardFragmentParams.cards.splice(index, 1);
    if (dc.length > 0) {
        toggleSelect(dc[0].cardId)
    }
}

async function submitAddCardFragment() {
    newCardFragmentParams.loading = true;

    const response = await apiCall("card.addFragment", {
        name: newCardFragmentParams.name,
        image: newCardFragmentParams.image,
        sort: newCardFragmentParams.sort,
        cards: newCardFragmentParams.cards,
    });

    newCardFragmentParams.loading = false;
    if (!response) {
        return false;
    }
    ElMessageBox.alert("可在此基础上修改部分配置继续增加卡片，若要清空数据重新配置，请点击底部清空按钮！", "增加卡包成功!", {
        confirmButtonText: 'OK',
        callback: (action) => { },
    });

    return true;
}

async function submitEditCardFragment() {
    newCardFragmentParams.loading = true;

    const response = await apiCall("card.modifyFragment", {
        id: newCardFragmentParams.id,
        name: newCardFragmentParams.name,
        image: newCardFragmentParams.image,
        sort: newCardFragmentParams.sort,
        cards: newCardFragmentParams.cards,
    });

    newCardFragmentParams.loading = false;
    if (!response) {
        return false;
    }
    ElMessage.success("修改卡包成功");
    return router.go(-1);
}

function cancel() {
    return router.go(-1);
}

onMounted(async () => {
    await cardStore.getAll();
    if (route.params.id) {
        await loadData(route.params.id);
    }
});
</script>

<style scoped>
.basic-part .el-row {
    margin-bottom: 10px;
}

.image-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
    gap: 10px;
}

.image-grid-inner {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
}

.image-grid-inner span {
    width: 100px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    text-align: center;
}

.image-grid-inner.selected {
    border-color: #409eff;
    box-shadow: 0 0 6px #a0cfff;
    border-radius: 4px;
    border: 1px solid #409eff;
}

.image-option {
    width: 100px;
    height: 140px;
    border-radius: 6px;
    object-fit: cover;
    cursor: pointer;
    transition: 0.2s;
}

.image-option:hover {
    transform: scale(1.05);
    box-shadow: 0 0 8px #ccc;
}

.card-config {
    padding: 12px;
    margin-bottom: 12px;
    border: 2px solid #dcdfe6;
    border-radius: 12px;
}
</style>
